import { render, staticRenderFns } from "./ListarRepartos.vue?vue&type=template&id=4cab21db&scoped=true&"
import script from "./ListarRepartos.vue?vue&type=script&lang=js&"
export * from "./ListarRepartos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab21db",
  null
  
)

export default component.exports